"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var ColorField_1 = __importDefault(require("../Field/ColorField/ColorField"));
var OpacityField_1 = __importDefault(require("../Field/OpacityField/OpacityField"));
var WidthField_1 = __importDefault(require("../Field/WidthField/WidthField"));
var LineDashField_1 = __importDefault(require("../Field/LineDashField/LineDashField"));
var LineCapField_1 = __importDefault(require("../Field/LineCapField/LineCapField"));
var LineJoinField_1 = __importDefault(require("../Field/LineJoinField/LineJoinField"));
var OffsetField_1 = __importDefault(require("../Field/OffsetField/OffsetField"));
var GraphicEditor_1 = __importDefault(require("../GraphicEditor/GraphicEditor"));
var _cloneDeep = require('lodash/cloneDeep');
var _get = require('lodash/get');
var _isEqual = require('lodash/isEqual');
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var CompositionContext_1 = require("../../CompositionContext/CompositionContext");
var CompositionUtil_1 = __importDefault(require("../../../Util/CompositionUtil"));
var Panel = antd_1.Collapse.Panel;
var LineEditor = /** @class */ (function (_super) {
    __extends(LineEditor, _super);
    function LineEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onColorChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.color = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onWidthChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.width = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOpacityChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.opacity = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onDasharrayChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.dasharray = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onDashOffsetChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.dashOffset = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onCapChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.cap = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onJoinChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.join = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onGraphicStrokeChange = function (gStroke) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.graphicStroke = gStroke;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onGraphicFillChange = function (gFill) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.graphicFill = gFill;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        /**
         * Wraps a Form Item around a given element and adds its locale
         * to the From Item label.
         */
        _this.wrapFormItem = function (locale, element) {
            var formItemLayout = {
                labelCol: { span: 8 },
                wrapperCol: { span: 16 }
            };
            return element == null ? null : (React.createElement(antd_1.Form.Item, __assign({ label: locale }, formItemLayout), element));
        };
        return _this;
    }
    LineEditor.prototype.shouldComponentUpdate = function (nextProps) {
        var diffProps = !_isEqual(this.props, nextProps);
        return diffProps;
    };
    LineEditor.prototype.render = function () {
        var _this = this;
        var symbolizer = this.props.symbolizer;
        var color = symbolizer.color, width = symbolizer.width, opacity = symbolizer.opacity, dasharray = symbolizer.dasharray, dashOffset = symbolizer.dashOffset, cap = symbolizer.cap, join = symbolizer.join, graphicStroke = symbolizer.graphicStroke, graphicFill = symbolizer.graphicFill;
        var locale = this.props.locale;
        return (React.createElement(CompositionContext_1.CompositionContext.Consumer, null, function (composition) { return (React.createElement("div", { className: "gs-line-symbolizer-editor" },
            React.createElement(antd_1.Collapse, { bordered: false, defaultActiveKey: ['1'], onChange: function (key) { return (null); } },
                React.createElement(Panel, { header: "General", key: "1" },
                    _this.wrapFormItem(locale.colorLabel, CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'LineEditor.colorField',
                        onChange: _this.onColorChange,
                        propName: 'color',
                        propValue: color,
                        defaultElement: React.createElement(ColorField_1.default, null)
                    })),
                    _this.wrapFormItem(locale.widthLabel, CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'LineEditor.widthField',
                        onChange: _this.onWidthChange,
                        propName: 'width',
                        propValue: width,
                        defaultElement: React.createElement(WidthField_1.default, null)
                    })),
                    _this.wrapFormItem(locale.opacityLabel, CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'LineEditor.opacityField',
                        onChange: _this.onOpacityChange,
                        propName: 'opacity',
                        propValue: opacity,
                        defaultElement: React.createElement(OpacityField_1.default, null)
                    })),
                    _this.wrapFormItem(locale.dashLabel, CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'LineEditor.lineDashField',
                        onChange: _this.onDasharrayChange,
                        propName: 'dashArray',
                        propValue: dasharray,
                        defaultElement: React.createElement(LineDashField_1.default, null)
                    })),
                    _this.wrapFormItem(locale.dashOffsetLabel, CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'LineEditor.dashOffsetField',
                        onChange: _this.onDashOffsetChange,
                        propName: 'offset',
                        propValue: dashOffset,
                        defaultElement: (React.createElement(OffsetField_1.default, { disabled: symbolizer.dasharray === undefined || _get(symbolizer, 'dasharray.length') === 0 }))
                    })),
                    _this.wrapFormItem(locale.capLabel, CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'LineEditor.capField',
                        onChange: _this.onCapChange,
                        propName: 'cap',
                        propValue: cap,
                        defaultElement: React.createElement(LineCapField_1.default, null)
                    })),
                    _this.wrapFormItem(locale.joinLabel, CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'LineEditor.joinField',
                        onChange: _this.onJoinChange,
                        propName: 'join',
                        propValue: join,
                        defaultElement: React.createElement(LineJoinField_1.default, null)
                    }))),
                React.createElement(Panel, { header: "Graphic Stroke", key: "2" }, CompositionUtil_1.default.handleComposition({
                    composition: composition,
                    path: 'LineEditor.graphicStrokeField',
                    onChange: _this.onGraphicStrokeChange,
                    propName: 'graphic',
                    propValue: graphicStroke,
                    onChangeName: 'onGraphicChange',
                    defaultElement: (React.createElement(GraphicEditor_1.default, { graphicTypeFieldLabel: locale.graphicStrokeTypeLabel, graphic: graphicStroke, graphicType: _get(graphicStroke, 'kind') }))
                })),
                React.createElement(Panel, { header: "Graphic Fill", key: "3" }, CompositionUtil_1.default.handleComposition({
                    composition: composition,
                    path: 'LineEditor.graphicFillField',
                    onChange: _this.onGraphicFillChange,
                    propName: 'graphic',
                    propValue: graphicFill,
                    onChangeName: 'onGraphicChange',
                    defaultElement: (React.createElement(GraphicEditor_1.default, { graphicTypeFieldLabel: locale.graphicFillTypeLabel, graphic: graphicFill, graphicType: _get(graphicFill, 'kind') }))
                }))))); }));
    };
    LineEditor.defaultProps = {
        locale: en_US_1.default.GsLineEditor
    };
    LineEditor.componentName = 'LineEditor';
    return LineEditor;
}(React.Component));
exports.LineEditor = LineEditor;
exports.default = LocaleWrapper_1.localize(LineEditor, LineEditor.componentName);
//# sourceMappingURL=LineEditor.js.map